<template>
  <ModalContainer :id="'appropriatenessModal'" large no-header>
    <form @submit.prevent="submit">
      <div class="modal-header bg-secondary">
        <h5 class="modal-title">
          We need to ask you a few details about your investment
          experience and appetite so we can complete our regulatory checks
        </h5>
        <ModalClose target="#appropriatenessModal"/>
      </div>
      <div class="modal-body">
        <p>
          We want to ensure that all our investors fully understand the investments that
          they are making and the risks (and potential rewards) that are on offer.
          As such, we would like to ask some questions so we can learn more about your experience and your attitude to risk.
        </p>
        <p class="mb-0">
          We treat all information in strictest confidence and by answering the questions you are helping us to meet our regulatory requirements.
          Completing the test should only take around 5 minutes (but could take longer depending on your
          own responses and considerations).
        </p>
      </div>
      <div class="modal-footer justify-content-between">
        <span>Estimated time to complete: <strong>5 minutes</strong></span>
        <div>
          <base-button class="mr-2" @click="$modal.close('#appropriatenessModal')">
            Not now
          </base-button>
          <base-button icon-right="arrow-right" primary :loading="saving" @click="submit">
            Let's go
          </base-button>
        </div>
      </div>
    </form>
  </ModalContainer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ModalClose from './ModalClose.vue'
import ModalContainer from './ModalContainer.vue'

export default {
  data: () => ({
    saving: false
  }),

  name: 'AppropriatenessModal',

  components: {
    ModalClose,
    ModalContainer
  },

  computed: {
    ...mapGetters({
      schema: 'core/user-appropriateness/schema'
    }),

    ...mapState({
      appropriateness: store => store.core.userAppropriateness.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      if (!this.$auth.user.appropriateness) {
        const appropriateness = this.schema
        appropriateness.user = this.$auth.user._id

        await this.$store.dispatch('core/user-appropriateness/save', appropriateness)
        await this.$store.dispatch('core/auth/patch', { appropriateness: this.appropriateness._id })
      }

      this.$modal.close('#appropriatenessModal')
      this.$router.push({ name: 'appropriateness.experience' })
    }
  }
}
</script>
